import { useState } from 'react';

import { captureUserActivity } from 'services/profile/api';
import useAuthStore from 'store/auth';
import { USER_ACTIVITY } from '../types';
import useDashboardQuestionnaire from './useDashboardQuestionnaire';
import useFaceScanStore from 'store/face-scan';
import useTourStore from 'store/app-tour';
import { signOut } from 'services/auth/api';

export default function useLogout() {
  const logout = useAuthStore((store) => store.logout);
  const clearScanStore = useFaceScanStore((store) => store.clearScanStore);
  const clearTourStore = useTourStore((store) => store.clearTourStore);

  const { onClearQuestionnaire } = useDashboardQuestionnaire();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const onLogout = async () => {
    setIsLoading(true);
    try {
      await captureUserActivity(USER_ACTIVITY.LOGOUT);
      await signOut();
    } catch (error) {
      console.error(error);
    }

    onClearQuestionnaire();
    logout();
    clearScanStore();
    clearTourStore();
    setIsLoading(false);
  };

  return { onLogout, isLoggingOut: isLoading };
}
